import React from "react";
import {
  SkeletonHeader,
  SkeletonCard,
  SkeletonText,
  SkeletonButton,
} from "../../UI/DesignStandards";

const SignupReviewSkeleton = () => {
  return (
    <div className="min-h-screen bg-brand-cream">
      <SkeletonHeader />

      <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8 py-8">
        <div className="space-y-6">
          {/* Signup Info Skeleton */}
          <SkeletonCard>
            <div className="space-y-4">
              <SkeletonText size="lg" width="1/3" />
              <div className="grid grid-cols-1 md:grid-cols-3 gap-4">
                <div className="space-y-2">
                  <SkeletonText size="sm" width="20" />
                  <SkeletonText size="md" width="32" />
                </div>
                <div className="space-y-2">
                  <SkeletonText size="sm" width="16" />
                  <SkeletonText size="md" width="24" />
                </div>
                <div className="space-y-2">
                  <SkeletonText size="sm" width="12" />
                  <SkeletonText size="md" width="20" />
                </div>
              </div>
            </div>
          </SkeletonCard>

          {/* Bowler Cards Skeleton */}
          <div className="space-y-4">
            {[1, 2].map((index) => (
              <SkeletonCard key={index}>
                <div className="space-y-4">
                  <div className="flex items-center justify-between">
                    <SkeletonText size="lg" width="32" />
                    <SkeletonText size="md" width="16" />
                  </div>
                  <div className="grid grid-cols-1 md:grid-cols-2 gap-4">
                    <div className="space-y-3">
                      <SkeletonText size="md" width="24" />
                      <SkeletonText size="md" width="36" />
                      <SkeletonText size="md" width="28" />
                    </div>
                    <div className="space-y-3">
                      <SkeletonText size="md" width="20" />
                      <SkeletonText size="md" width="32" />
                      <SkeletonText size="md" width="24" />
                    </div>
                  </div>
                  <div className="pt-4 border-t">
                    <SkeletonText size="md" width="40" />
                  </div>
                </div>
              </SkeletonCard>
            ))}
          </div>

          {/* Cost Summary Skeleton */}
          <SkeletonCard>
            <div className="space-y-4">
              <SkeletonText size="lg" width="1/4" />
              <div className="space-y-3">
                <div className="flex justify-between">
                  <SkeletonText size="md" width="32" />
                  <SkeletonText size="md" width="16" />
                </div>
                <div className="flex justify-between">
                  <SkeletonText size="md" width="24" />
                  <SkeletonText size="md" width="12" />
                </div>
                <div className="border-t pt-3">
                  <div className="flex justify-between">
                    <SkeletonText size="lg" width="20" />
                    <SkeletonText size="lg" width="20" />
                  </div>
                </div>
              </div>
            </div>
          </SkeletonCard>

          {/* Action Buttons Skeleton */}
          <SkeletonCard>
            <div className="space-y-4">
              <SkeletonText size="lg" width="16" />
              <div className="flex flex-col sm:flex-row gap-4">
                <SkeletonButton size="md" width="40" />
                <SkeletonButton size="md" width="36" />
                <SkeletonButton size="md" width="28" />
              </div>
            </div>
          </SkeletonCard>
        </div>
      </div>
    </div>
  );
};

export default SignupReviewSkeleton;
